import { mdiArrowRight, mdiEmail, mdiPhone } from "@mdi/js";
import { useHead } from "../services/common";
import Icon from "@mdi/react";

export default function Accommodations() {

    useHead({
        title: "Ubytování Chata Babetta Poniklá | T.J. Sokol Poniklá",
        description: "Nabídka ubytování v areálu T.J. Sokol Poniklá na chatě Babetta. Ideální pro sportovní soustředění, školy v přírodě či rodinnou rekreaci v Krkonoších."
    });

    return <>
        <div className="header">
            <h1>Ubytování</h1>
        </div>
        <section className="width-max">
            <div className="content-box">
                <h2>Ubytování <span className="red">SOKOLU</span> Poniklá</h2>
                <div className="h2-line" />

                <div className="accommodations-picture" />

                <ul className="accommodations-info">
                    <li>
                        <div className="icon"><Icon path={mdiPhone} size={1} /></div>
                        <div>
                            <h3>Telefon</h3>
                            <p>+420 605 759 389</p>
                        </div>
                    </li>
                    <li>
                        <div className="icon"><Icon path={mdiEmail} size={1} /></div>
                        <div>
                            <h3>Email</h3>
                            <p>info@sokolponikla.cz</p>
                        </div>
                    </li>
                </ul>

                <a className="button center float-stop" href="https://www.booking.com/hotel/cz/chata-babeta.cs.html" target="__blank">Zamluvit ubytování <Icon path={mdiArrowRight} size={0.9} /></a>

            </div>
        </section>

        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d655.9042456465932!2d15.459258033537928!3d50.660200189235404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470ec715447b7ae7%3A0x589baa5c4914252a!2sChata%20BABETA!5e0!3m2!1sen!2scz!4v1746437783906!5m2!1sen!2scz" width="100%" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        <div style={{ marginBottom: "-110px" }} />
    </>;
}